module.exports = __webpack_public_path__ + "static/media/LOGO_GEO_PARQUEADERO-01.55b5df4c.png";